// extracted by mini-css-extract-plugin
export default {"hideTooltip":"o9-z","fadeIn":"p9-z","delay":"q9-z","recommendedSizeTooltip":"r9-z"};